import Paper from '@mui/material/Paper'
import Text from '@mui/material/Typography'

function Active(){
   return (
      <Paper style={{ padding: 10, minHeight:700 }} >

         <Text variant='h5' color='textSecondary'>Active</Text>
         <div align='center' style={{margin:0, padding:50, backgroundColor:'#f1f1f1'}}>
            <Text variant='body1' color='textSecondary'>
               Active posts, newsletters, etc.
            </Text>
         </div>

      </Paper>
   )
}
export default Active
